import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import externalEndpoints from '@constants/configs/externalEndpoints';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { SsapData, IExchangeProgramNames } from '@components/ssap/SsapTypes';

interface IMoneyPursueAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    formName: string,
    isAsteriskShown: boolean,
    exchangeAndProgramNames: IExchangeProgramNames
}

const MoneyPursueAttestation = (props: IMoneyPursueAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            legalAttestations: {
                agreeToMoneyPursual
            }
        },
        formName,
        exchangeAndProgramNames,
        isAsteriskShown = true
    } = props;
    const { exchangeMedicaid, exchangeMedicaidOrChip } = exchangeAndProgramNames;

    const labelClass = classnames({
        'required-true': isAsteriskShown
    }) ;

    return (
        <UniversalInput
            label = { {
                text: 'ssap.input.label.agree_to_money_pursual',
                labelClass: [ labelClass ],
                labelTextReplacements: {
                    link: (
                        <a
                            className = 'usa-link--external'
                            href = { externalEndpoints.GA_LINKS.ESTATE_RECOVERY }
                            target = '_blank'
                            rel = 'noopener noreferrer'
                        >
                            <FormattedMessage id = 'ssap.sign_and_review.estate_recovery_link' />
                        </a>
                    ),
                    exchangeMedicaidOrChip,
                    exchangeMedicaid
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'agreeToMoneyPursual',
                classes: [ 'disp-styl' ],
                checked: agreeToMoneyPursual,
                value: agreeToMoneyPursual,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ 'legalAttestations' ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};
export default MoneyPursueAttestation;